import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { AuthRouteBoundary } from './AuthRouteBoundary';
import 'katex/dist/katex.min.css';
import './styles.css';
import './enhancements.css';

if ('serviceWorker' in navigator && import.meta.env.PROD) navigator.serviceWorker.register('/sw.js').catch(() => undefined);

const localeReady = ((window as any).__FEEDDIVE_UI_READY__ as Promise<void> | undefined) ?? Promise.resolve();
void localeReady.finally(() => {
  if ((window as any).__FEEDDIVE_UI_BLOCK_APP__) return;
  const root = document.getElementById('root')!;
  ReactDOM.createRoot(root).render(
    <React.StrictMode>
      <BrowserRouter>
        <AuthRouteBoundary>
          <App />
        </AuthRouteBoundary>
      </BrowserRouter>
    </React.StrictMode>,
  );
  requestAnimationFrame(() => {
    (window as any).__FEEDDIVE_UI_TRANSLATE__?.(root);
    (window as any).__FEEDDIVE_UI_REVEAL__?.();
  });
});
